import React, { useState, useEffect } from 'react';
import useAsync from '../hooks/useAsync';
import PushMessageServices from '../services/PushMessageServices.js';
import PushStatus from './TogelButton/PushStatus';

function PushMessage() {
  const { data, error, isLoading, run } = useAsync(PushMessageServices.getMessage);

  const [messages, setMessages] = useState({
    message1: '',
    message2: '',
    messageStatus1: '',
    messageStatus2: ''
  });

  useEffect(() => {
    
    if (data && data.data) {
      setMessages({
        message1: data.data.message1,
        message2: data.data.message2,
        messageStatus1: data.data.messageStatus1,
        messageStatus2: data.data.messageStatus2,
      });
    }
  }, [data]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await PushMessageServices.updateMessage({
        message1: messages.message1,
        message2: messages.message2,
        messageStatus1: messages.messageStatus1,
        messageStatus2: messages.messageStatus2,
      });
      alert('Push Message updated successfully!');
    } catch (error) {
      console.error('Failed to update Push Message:', error);
      alert('Failed to update Push Message. Please try again.');
    }
  };

  const handleStatusChange = (page, status) => {
    setMessages((prevMessages) => ({
      ...prevMessages,
      [page === 'message1' ? 'messageStatus1' : 'messageStatus2']: status
    }));
  };

  return (
    <div className="right_col" role="main">

                 <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
            
                      <div className="my-auto">
            
                        <h5 className="page-title fs-21 mb-1">
                        Push Notification
                        </h5>
                        <nav>
            
                          <ol className="breadcrumb mb-0">
            
                            <li className="breadcrumb-item">
                              <a href="javascript:void(0);">Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                            Notification
                            </li>
                          </ol>
                        </nav>
                      </div>
                      <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                       
                     
            
            
            
                      </div>
                    </div>
           
      
    
      <div className="container-box">
        <div className="container-box-inner table-reponsive-tabe">
              <div className="page-details profile-details">
                <h4>Push Messages</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-field push-notification">
                        <div className="d-flex align-items-center">
                          <div className="status-toggle me-3">
                            <PushStatus 
                              data={messages.messageStatus1} 
                              page="message1" 
                              onSuccess={(newStatus) => handleStatusChange('message1', newStatus)} 
                            />
                          </div>
                          <label>After Successful Registration Message</label>
                        </div>
                        <textarea
                          className="form-control py-2 px-3 mt-2"
                          style={{ height: 68 }}
                          value={messages.message1}
                          onChange={(e) => setMessages({ ...messages, message1: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-field push-notification">
                        <div className="d-flex align-items-center">
                          <div className="status-toggle me-3">
                            <PushStatus 
                              data={messages.messageStatus2} 
                              page="message2" 
                              onSuccess={(newStatus) => handleStatusChange('message2', newStatus)} 
                            />
                          </div>
                          <label>Registration Approved Message</label>
                        </div>
                        <textarea
                          className="form-control py-2 px-3"
                          style={{ height: 68 }}
                          value={messages.message2}
                          onChange={(e) => setMessages({ ...messages, message2: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="submit-green-btn">SUBMIT</button>
                </form>
              </div>
         
        </div>
      </div>
    </div>
  );
}

export default PushMessage;
